import { get } from '../axios'

interface OrderDetails {
  c_id: number
  price: number
  discount: number
  quantity: number
  product_variant: number
}
interface ComboOrderDetails {
  parent_id: string[]
  parent_type: string
  item_variant: 'COMBO' | 'KIT'
  quantity: number
  price: number
  discount: number
}

type CartResponse = {
  cart_id: string
  order_details: OrderDetails[] | ComboOrderDetails[]
  vendor: number
}
export const fetchCartDetailsById = async (cartId: string) => {
  const url = `/hyperlocal/v1/cart/${cartId}`
  return await get<CartResponse>(url)
}

export const isComboOrder = (
  detail: OrderDetails | ComboOrderDetails,
): detail is ComboOrderDetails => {
  return 'parent_type' in detail
}
